import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainApp from "./MainApp.js";
import Docs from "./docs.js";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/docs" element={<Docs />} />
        <Route path="/" element={<MainApp />} />
        <Route path="/:apiKey" element={<MainApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
